<template>
  <div class="conmain">
     <div v-if="liad_show">
          <load></load>
        </div>
    <el-button type="primary" round @click="file_up('add','')">新增文档</el-button>
    <el-table stripe :data="file_list.data" style="width: 100%">
      <el-table-column label="编号" prop="num">
      </el-table-column>
      <el-table-column label="文档名" prop="name">
      </el-table-column>
      <el-table-column label="添加人" prop="a_id">
      </el-table-column>
      <el-table-column label="分类" prop="type">
      </el-table-column>
      <el-table-column label="时长(秒)" prop="time">
      </el-table-column>
      <el-table-column label="是否开放" sortable>
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.open"
            @change="open(scope.$index)"
            active-color="#13ce66"
            inactive-color="#ff4949">
          </el-switch>
         </template>
      </el-table-column>
      <el-table-column label="转码" sortable>
        <template slot-scope="scope">
           <p v-if="scope.row.html=='0'" style="cursor: pointer;" @click="html(scope.$index)">转码</p>
           <p v-if="scope.row.html=='2'">转码中</p>
           <p v-if="scope.row.html=='1'" style="cursor: pointer;" @click="html(scope.$index)">重新转码</p>
         </template>
      </el-table-column>
      <el-table-column label="附加文件" sortable>
        <template slot-scope="scope">
           <p v-if="scope.row.file_link!='0'" style="cursor: pointer;" @click="file_link_watch(scope.row)">查看</p>
           <p v-else style="cursor: pointer;">无</p>
         </template>
      </el-table-column>
      <el-table-column label="讲解视频" sortable>
        <template slot-scope="scope">
           <p v-if="scope.row.video!='0'" style="cursor: pointer;" @click="file_video_watch(scope.$index)">查看</p>
           <p v-else style="cursor: pointer;" @click="file_video_up(scope.$index,'add')">添加</p>
         </template>
      </el-table-column>
      <el-table-column label="状态" sortable>
        <template slot-scope="scope">
           <p v-if="scope.row.status=='1'">启用中</p>
           <p v-else>已禁用</p>
         </template>
      </el-table-column>
      <el-table-column align="right" width="220">
        <template slot="header" slot-scope="scope">
          <el-input v-model="search" size="mini" @keyup.enter.native="search_click()" placeholder="输入关键字搜索" />
        </template>
        <template slot-scope="scope">
          <el-button size="mini" type="success" plain @click.native="file_watch(scope.$index)">预览</el-button>
          <el-button size="mini" type="primary" plain @click="file_up('edit', scope.row.num)">编辑</el-button>
          <el-button size="mini" type="success" v-if="scope.row.status!='1'" plain @click="file_del(scope.row.num)">启用</el-button>
          <el-button size="mini" type="danger" v-else plain @click="file_del(scope.row.num)">禁用</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="block">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="file_list.current_page" :page-sizes="[10, 20, 30, 40]" :page-size="file_list.per_page"
        layout="total, sizes, prev, pager, next, jumper" :total="file_list.total">
      </el-pagination>
    </div>

    <el-dialog :title="nav_status.file_dialog_title" :visible.sync="nav_status.file_dialog">
     <p>文档名:&nbsp;&nbsp;&nbsp;&nbsp;<el-input v-model="file_edit.name" placeholder="请输入内容" style="width: 50%;"></el-input></p>
     <p>文档分类:
          <div v-html="type_choiced.html" @click="del_type_edit_fid_click($event)"></div>
          <el-button plain @click="type_choice()">请选择</el-button>
     </p>
     <p>文档
      <el-upload
        class="upload-demo"
        accept=".pdf"
        ref="upload"
        action=""
        :http-request="file_save"
        :on-exceed="file_check"
        :file-list="fileList"
        :on-change="file_change"
        :before-remove="file_remove"
        :limit="1"
        :auto-upload="false">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        </el-upload>
     </p>
     <p>阅读时长:&nbsp;&nbsp;&nbsp;&nbsp;<el-input v-model="file_edit.time" type='number' placeholder="阅读时长" style="width: 50%;"></el-input> <span>秒</span></p>
     <p>附加链接:&nbsp;&nbsp;&nbsp;&nbsp;<el-input v-model="file_edit.file_link" placeholder="附加链接" style="width: 50%;"></el-input></p>
      <div slot="footer" class="dialog-footer">
      <el-button @click="nav_status.file_dialog=false">取 消</el-button>
      <el-button type="primary" @click="file_submit()">确 定</el-button>
    </div>
    </el-dialog>

    <el-dialog :title="nav_status.file_video_dialog_title" :visible.sync="nav_status.file_video_dialog">
     <p>视频类型:&nbsp;&nbsp;&nbsp;&nbsp;
      <el-select v-model="file_video_edit.video_type" filterable placeholder="请选择">
       <el-option label="平台视频" value="0"></el-option>
       <el-option label="本地上传" value="1"></el-option>
      </el-select>
     </p>
     <p v-if="file_video_edit.video_type=='0'">视频:&nbsp;&nbsp;&nbsp;&nbsp;
       <el-select v-model="file_video_edit.video" filterable placeholder="请选择">
        <el-option
         v-for="item in video_list"
         :key="item.num"
         :label="item.name"
         :value="item.num">
        </el-option>
       </el-select>
     </p>
     <p v-if="file_video_edit.video_type=='1'">本地上传
      <el-upload
        class="upload-demo"
        accept=".mp4"
        ref="upload_video"
        action=""
        :http-request="file_video_save"
        :on-exceed="file_video_check"
        :file-list="file_video_list"
        :on-change="file_video_change"
        :before-remove="file_video_remove"
        :limit="1"
        :auto-upload="false">
        <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
        </el-upload>
     </p>
     <div slot="footer" class="dialog-footer">
      <el-button @click="nav_status.file_video_dialog=false">取 消</el-button>
      <el-button type="primary" @click="file_video_submit()">确 定</el-button>
    </div>
    </el-dialog>

    <el-dialog
      title="讲解视频"
      :visible.sync="nav_status.file_video_watch_dialog"
      width="30%"
      ref="player-el-dialog"
      :before-close="file_video_watch_close">
      <video ref="videoPlayer" class="video-js"></video>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="file_video_edit_click()">更 换</el-button>
      </div>
    </el-dialog>

    <el-dialog title="所属分类":visible.sync="nav_status.type_choice_dialog" :before-close="handleClose" width="80%">
      <div>
        <h4>您选择的是:
        <span v-html="type_choiced.html" @click="del_type_edit_fid_click($event)"></span>
        </h4>
        <el-input
        style="margin: 0.625rem;"
        placeholder="输入关键字进行过滤"
          v-model="filterText">
        </el-input>
        <div>
          <!-- <el-tree @node-click="type_fid"
             :data="type_list"
              ref="tree"
              node-key="num"
             :default-expanded-keys="tree_default"
             :props="defaultProps">
         </el-tree> -->
         <el-row class="over" :style="{height:dialog_Height}">
           <el-tree
            :filter-node-method="filterNode"
              @node-click="type_fid"
               :data="type_list"
                ref="tree"
                node-key="num"
               :default-expanded-keys="tree_default"
               :props="defaultProps">
               <span class="custom-tree-node" slot-scope="{data}">
                 <div class="dia_tree_data" :style="{width:dialog_width}" >{{ data.name }}</div>
               </span>
           </el-tree>
         </el-row>
        </div>
      </div>

       <div slot="footer" class="dialog-footer">
         <el-button @click="type_choice_remove()">取 消</el-button>
         <el-button type="primary" @click="nav_status.type_choice_dialog = false">确 定</el-button>
       </div>
    </el-dialog>

    <el-dialog title="预览"
          :visible.sync="pdf.show" width="30%" center
           @close='pdf_closeDialog'>
             <div style="margin-bottom: 15px; text-align: right">
              <el-button type="primary" size="small" @click.stop="pdf_previousPage">
                 上一页
               </el-button>
               <el-button type="primary" size="small" @click.stop="pdf_nextPage">
               下一页
              </el-button>
              <span>当前第{{pdf.pdfPage}}页 / 共{{pdf.pageCount}}页</span>
            </div>
            <div >
             <pdf
               :src="pdf.src"
               :page="pdf.pdfPage"
               @num-pages="pdf.pageCount = $event"
               @page-loaded="pdf.pdfPage = $event"
               style="display: inline-block; width: 100%"
            ></pdf>
          </div>
        </el-dialog>
  </div>

</template>

<script>
  import pdf from 'vue-pdf'
  import load from '../../../../components/load.vue';
  export default {
    watch: {
         filterText(val) {
           this.$refs.tree.filter(val);
         }
       },
    data() {
      return {
        filterText:'',
        dialog_width:window.innerWidth -500 + 'px',
        dialog_Height:window.innerHeight * 0.5 + 'px',
        liad_show:'',
        pdf:{
          show: false,
          src: null,
          pdfPage : 1,
          pageCount: 0,
        },
        player: null,
        videoOptions: {
          // lang: 'zh-CN',
          autoplay: false,//自动播放
          controls: true,//用户可以与之交互的控件
          loop:false,//视频一结束就重新开始
          muted:false,//默认情况下将使所有音频静音
          aspectRatio:"16:9",//显示比率
          preload:false,//预加载
          playbackRates: [0.5, 1, 1.5,2],//倍数
          fullscreen:{
              options: {navigationUI: 'hide'}
          },
          sources:[{
            src: "",
            type: "video/mp4"
          }]
        },
        tree_default:[],
        defaultProps: {
          children: 'children',
          label: 'name'
        },
        fileList: [],
        file_video_list: [],
        nav_status:{
          type_choice_dialog:false,
          file_dialog:false,
          type:'',
          submit_type:'',
          file_video_dialog_title:'',
          file_video_dialog:false,
          file_video_watch_dialog:false,
        },
        file_list:{
          current_page: 1, // 当前页码
          total: 0, // 总条数
          per_page: 10,
        },
        type_list:{},
        file_edit:{},
        file_video_edit:{
          video_type:''
        },
        video_list:{},
        type_choiced:{
          html:''
        },
        search: ''
      }
    },
    components: {pdf,
    load:load
    },

    mounted() {
      this.get_file(),
      this.get_type(),
      this.get_video()
    },

    methods: {
      filterNode(value, data) {
         if (!value) return true;
         return data.name.indexOf(value) !== -1;
       },
      search_click(){
        this.get_file()
      },
      file_watch(num){
        this.pdf.src = pdf.createLoadingTask(this.file_list['data'][num]['file'])
        this.pdf.show = true
      },

      //关闭窗口初始化PDF页码
      pdf_closeDialog(){
        this.pdf.pdfPage = 1;
      },

      //PDF改变页数
      pdf_previousPage(){
        var p = this.pdf.pdfPage
        p = p>1?p-1:this.pdf.pageCount
        this.pdf.pdfPage = p
      },
      pdf_nextPage(){
        var p = this.pdf.pdfPage
        p = p<this.pdf.pageCount?p+1:1
        this.pdf.pdfPage = p
      },

      file_video_up(file,type){
        let _this=this
        _this.file_video_edit={video_type:''}
        _this.file_video_edit.type=type
        _this.file_video_edit.file=file
        if(_this.$refs.upload_video){
          _this.$refs.upload_video.clearFiles()
        }
        if(type=='add'){
          _this.nav_status.file_video_dialog_title='添加'
        }else{
          _this.nav_status.file_video_dialog_title='编辑'
        }
        _this.file_video_edit.num=_this.file_list['data'][file]['num']
        _this.nav_status.file_video_dialog=true
      },

      file_video_watch(file){
        let _this=this
        _this.axios.get('/v2/c_resource/get_file_video',{params:{'num':_this.file_list['data'][file]['num']}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.file_video_edit.type='edit'
              _this.file_video_edit.file=file
              _this.nav_status.file_video_watch_dialog=true
              _this.videoOptions.sources[0].src=res.data.data
              _this.start_player()
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      start_player(){
        let _this=this
        if(_this.player){
          document.getElementsByClassName('vjs-tech')[0].src=_this.videoOptions.sources[0].src
          _this.player.load()
        }else{
          _this.$nextTick(()=>{
            _this.player = _this.$video(_this.$refs.videoPlayer, _this.videoOptions, function onPlayerReady() {

            })
          })
        }
      },
      del_player() {
        //  组件销毁时，清除播放器
        if (this.player) {
          this.player.dispose() // 该方法会重置videojs的内部状态并移除dom
        }
      },

      file_video_watch_close(done){
        let _this=this
        _this.player.pause()
        _this.nav_status.file_video_watch_dialog=false
      },

      file_video_edit_click(){
        let _this=this
        _this.player.pause()
        _this.nav_status.file_video_watch_dialog=false
        _this.file_video_up(_this.file_video_edit.file,_this.file_video_edit.type)
      },

      get_file(){
        let _this=this
        _this.liad_show=true
        _this.axios.get('/v2/c_resource/get_file',{params:{'page':_this.file_list.current_page,'limit':_this.file_list.per_page,'keyword':_this.search}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.liad_show=false
              for(var i=0;i<res.data.data.data.length;i++){
                if(res.data.data.data[i].open=='1'){
                  res.data.data.data[i].open=true
                }else{
                  res.data.data.data[i].open=false
                }
              }
              _this.file_list=res.data.data
              _this.file_list.per_page=parseInt(_this.file_list.per_page)
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      get_type(){
        let _this=this
        _this.axios.get('/v2/c_resource/get_file_type').then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.type_list=res.data.data
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      get_video(){
        let _this=this;
        _this.axios.get('/v2/c_resource/get_video',{params:{'page':'1','limit':'9999','type':'1','status':'1'}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.video_list=res.data.data.data
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      get_file_info(num){
        let _this=this;
        _this.axios.get('/v2/c_resource/get_file_info',{params:{'num':num}}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.file_edit=res.data.data
              _this.change_type_choiced()
              _this.show_file_dialog()
            }else{
              _this.$message.error(res.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      handleSizeChange(val) {
        this.file_list.current_page = 1;
        this.file_list.per_page = val
        this.get_file()
      },

      handleCurrentChange(val) {
        let _this=this
        _this.file_list.current_page = val
        _this.get_file()
      },

      show_file_dialog(){
        let _this=this
        _this.nav_status.file_dialog=true
        if(_this.$refs.upload){
            _this.$refs.upload.clearFiles()
        }
      },

      file_up(type,num){
        let _this=this
        _this.file_edit={}
        _this.type_choiced.html=''
        _this.file_edit.resource_type={}
        _this.nav_status.submit_type=type
        if(type=='add'){
          _this.show_file_dialog()
        }else{
          _this.get_file_info(num)
        }
      },

      type_choice(){
        this.nav_status.type_choice_dialog=true
      },

      type_fid(data){
        let _this=this
        _this.type_choiced.html=''
        _this.file_edit.resource_type={}
        _this.save_type_edit_fid(data)
      },

      change_type_choiced(){
        let _this=this
        _this.type_choiced.html=''
        for(let key  in _this.file_edit.resource_type){
          _this.type_choiced.html+="<span>"+_this.file_edit.resource_type[key]+"<span class='"+key+"' style='padding:0 20px;cursor:pointer'>X</span></span>"
        }
      },

      del_type_edit_fid_click:function(event){
        let _this=this
        if(event.target.className){
          _this.del_type_edit_fid(event.target.className)
        }else{
          return false;
        }
      },

      save_type_edit_fid(data){
        let _this=this
        _this.file_edit.resource_type[data.num]=data.name
        _this.change_type_choiced()
      },

      del_type_edit_fid(num){
        let _this=this
        delete _this.file_edit.resource_type[num];
        _this.change_type_choiced()
      },

      type_choice_remove(done){
        let _this=this
        _this.$confirm('确认取消所选分类？').then(_ => {
          _this.type_choiced.html=''
          _this.file_edit.resource_type={}
          done();
        })
        .catch(_ => {});
      },

      handleClose(done) {
        let _this=this
        _this.$confirm('确认所选分类？').then(_ => {
          done();
        })
        .catch(_ => {});
      },

      file_submit(){
        let _this=this
        if(_this.nav_status.submit_type=='add'){
            if(_this.fileList==0){
              _this.$message.error('请选择文件')
            }else{
              _this.$refs.upload.submit()
            }
        }else{
          if(_this.fileList==0){
            _this.save()
          }else{
            _this.$refs.upload.submit()
          }
        }

      },

      file_save(file){
        let _this=this
        var files =file.file
        var data = new FormData();
        data.append('type',_this.nav_status.submit_type)
        if(_this.nav_status.submit_type!='add'){
          data.append("num", _this.file_edit.num)
        }
        data.append("name", _this.file_edit.name)
        data.append("time", _this.file_edit.time)
        data.append("file_link", _this.file_edit.file_link)
        data.append("file", files)
        if(_this.file_edit.hasOwnProperty('resource_type')){
          var temp=Array()
          for(var key in _this.file_edit.resource_type){
            temp.push(key)
          }
          data.append("resource_type", temp[0])
        }
        _this.axios.post('/v2/c_resource/file_up',data,{ headers: { "Content-Type": "multipart/form-data" } }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.get_file()
              _this.nav_status.file_dialog=false
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      save(){
        let _this=this
        var data = new FormData();
        data.append("num", _this.file_edit.num)
        data.append('type',_this.nav_status.submit_type)
        data.append("name", _this.file_edit.name)
        data.append("time", _this.file_edit.time)
        data.append("file_link", _this.file_edit.file_link)
        if(_this.file_edit.hasOwnProperty('resource_type')){
          var temp=Array()
          for(var key in _this.file_edit.resource_type){
            temp.push(key)
          }
          data.append("resource_type", temp[0])
        }
        _this.axios.post('/v2/c_resource/file_up',data,{ headers: { "Content-Type": "multipart/form-data" } }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.get_file()
              _this.nav_status.file_dialog=false
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      file_del(file){
        let _this=this
        _this.axios.post('/v2/c_resource/file_up',{'type':'del','num':file}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.get_file()
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      file_check(){
        let _this=this
        _this.$message.error('请先删除列表中的文件')
      },

      file_change(file, fileList){
        let _this=this
        _this.fileList=fileList
      },

      file_remove(){
        this.fileList=[]
      },

      file_video_check(){
        let _this=this
        _this.$message.error('请先删除列表中的文件')
      },

      file_video_change(file, fileList){
        let _this=this
        _this.file_video_list=fileList
      },

      file_video_remove(){
        this.file_video_list=[]
      },

      file_video_submit(){
        let _this=this
        if(_this.file_video_edit.video_type==''){
          _this.$message.error('请选择视频类型')
        }else{
          if(_this.file_video_edit.video_type=='0'){
            _this.file_video_submit_end();
          }else{
            if(_this.file_video_list==0){
              _this.$message.error('请选择视频文件')
            }else{
              _this.$refs.upload_video.submit()
            }
          }
        }
      },

      file_video_submit_end(){
        let _this=this
        var data = new FormData();
        data.append('type',_this.file_video_edit.type)
        data.append('video_type',_this.file_video_edit.video_type)
        data.append('video',_this.file_video_edit.video)
        data.append('num',_this.file_video_edit.num)
        _this.axios.post('/v2/c_resource/file_video',data,{ headers: { "Content-Type": "multipart/form-data" } }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.file_list['data'][_this.file_video_edit.file]['video']=res.data.data
              _this.nav_status.file_video_dialog=false
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      file_video_save(file){
        let _this=this
        var data = new FormData();
        data.append('type',_this.file_video_edit.type)
        data.append('video_type',_this.file_video_edit.video_type)
        data.append('num',_this.file_video_edit.num)
        data.append("video", file.file)
        _this.axios.post('/v2/c_resource/file_video',data,{ headers: { "Content-Type": "multipart/form-data" } }).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.file_list['data'][_this.file_video_edit.file]['video']=res.data.data
              _this.nav_status.file_video_dialog=false
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      html(file){
        let _this=this
        var num=_this.file_list['data'][file]['num']
        _this.$set(_this.file_list['data'][file],'html','2')
        _this.axios.post('/v2/c_resource/file_html',{data:num}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.$set(_this.file_list['data'][file],'html','1')
            }else{
              _this.$message.error(res.data.msg)
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },
      open(file){
        let _this=this
        var num=_this.file_list['data'][file]['num']
        _this.axios.post('/v2/c_resource/file_open',{data:num}).then(function(res) {
          if(res.status=='200'){
            if(res.data.code=='1'){
              _this.$message.success(res.data.msg)
              _this.$set(_this.file_list['data'][file],'open',res.data.data)
            }else{
              _this.$message.error(res.data.msg)
              if(_this.file_list['data'][file]['open']){
                _this.$set(_this.file_list['data'][file],'open',false)
              }else{
                _this.$set(_this.file_list['data'][file],'open',true)
              }
            }
          }else{
            _this.$message.error('服务器内部错误')
          }
        }).catch(function(error) {
          _this.$message.error('服务器内部错误')
        });
      },

      file_link_watch(file){
        window.open(file.file_link, '_blank');
      },

    },


    }
</script>

<style scoped>
  .eidtbtn {
    padding: 0 40px;
    line-height: 40px;
  }
  .conmain {
    width: 100%;
    height: 100%;
    overflow: hidden;
  }

  .block {
    text-align: center;
    margin-top: 20px;
  }
  .ercitankuang_left{
   border:1px solid 	#9D9D9D;
   height: 200px;
   flex: 1;
   overflow:scroll;
  }
  .ercitankuang_right{
    border:1px solid 	#9D9D9D;
    height: 200px;
    flex: 1;
    overflow:scroll;
  }
  >>>.el-tree>.el-tree-node {
    width: calc(100% - 45px);
    border: 2px solid #f6f8ff;
    /* box-shadow: 5px 5px 3px #f6f8ff; */
    padding: 5px;
    margin: 0.625rem;
  }
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
   .tree_data{
     overflow: hidden;
     text-overflow: ellipsis;
   }
   .dia_tree_data{
     overflow-x: hidden;
     text-overflow: ellipsis;
   }
   .over{
     overflow: auto;
     overflow-x:hidden;
   }
</style>



// WEBPACK FOOTER //
// src/view/company/course/SelfFile/File.vue